<template>
	<ChalkyUtilityGallery
		class="view-venue-gallery venue-gallery"
		v-bind:interactive="true"
		v-bind:model="venueModel"
		v-on:tap:small="Handle_OnTapGallery"
	/>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays an interactive photo gallery for a venue.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueGallery extends ViewBase {
		/**
		 * The venue model containing gallery media
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Emits tap event to parent for handling gallery expansion
		 *
		 * @param Event e
		 * @return void
		 */
		protected Handle_OnTapGallery(e: Event): void {
			this.$emit('tap', e);

			ChalkySticks.Utility.Analytics.track('place:gallery.toggle');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-gallery {
		height: 285px;
		z-index: 0;

		~ * {
			position: relative;
		}
	}
</style>
